// src/components/ProtectedRoute.tsx
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@src/context/AuthContext';
import { useLocale } from '../../i18n/LocaleContext';

export const ProtectedRoute: React.FC = () => {
  const { t } = useLocale();
  const { user, loading } = useAuth();

  if (loading) {
    // You can render a loader or a splash screen while checking auth state
    return <div>{t('auth.loading')}</div>;
  }

  if (!user) {
    // Not logged in → redirect to login page
    return <Navigate to="/login" replace />;
  }

  // Logged in → render all nested routes
  return <Outlet />;
};
